import { createSlice } from "@reduxjs/toolkit";

const initialState= {
    logs: null,
}

const adminInsightsSlice = createSlice({
    name: "admininsights",
    initialState: initialState,
    extraReducers: (builder) => {
        builder
         .addCase('LOGOUT', (state) => {
            Object.assign(state, initialState);
         })
    },
    reducers:{
        storeAdminAuditLogs: (state, action) => {
            state.logs= action.payload;
        }
    }
})

export const { storeAdminAuditLogs } = adminInsightsSlice.actions
export default adminInsightsSlice.reducer